import { ReactNode, useState } from 'react';
import classNames from 'classnames';

import { TabList, Tab, SelectTabEvent, SelectTabData, TabValue } from '@fluentui/react-components';

import { NavDrawer } from '@shared/components';
import { TMap } from '@shared/types';

import { TPath } from '@modules/items/types/folders.types';
import { getImmediateParentId } from '../../helpers/items.helper';
import { ITEMS_NAV_DRAWER_WIDTH_PX } from '../../constants';

type TProps = {
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
  tabs: TMap<string, ReactNode>;
  resolvedPath: TPath;
  // Explicit back-link override. Defaults to the parent folder of the last path
  // item, which works for normal items-in-folders but not for virtual list pages
  // like /folder/:id/literatures, which supply their own href.
  hrefBack?: string;
};
const ItemsNavDrawer = ({ isOpen, setIsOpen, tabs, resolvedPath, hrefBack }: TProps) => {
  const [selectedValue, setSelectedValue] = useState<TabValue>(Object.keys(tabs)[0]);
  // A page can drop the selected tab, e.g. its Insights tab once no document is shown.
  const shownValue = (selectedValue as string) in tabs ? (selectedValue as string) : Object.keys(tabs)[0];
  const onTabSelect = (event: SelectTabEvent, data: SelectTabData) => setSelectedValue(data.value);

  return (
    <NavDrawer
      type="inline"
      appearance="card"
      title="Details"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      hrefBack={hrefBack ?? `/folder/${getImmediateParentId(resolvedPath)}`}
      withPanelContractIcon
      width={`${ITEMS_NAV_DRAWER_WIDTH_PX}px`}
    >
      <div className="w-full flex border-b border-neutral-300">
        <TabList
          selectedValue={shownValue}
          onTabSelect={onTabSelect}
          className={classNames({
            'pl-2': Object.keys(tabs).length < 3,
            'mx-auto': Object.keys(tabs).length >= 3,
          })}
        >
          {Object.keys(tabs).map((key) => (
            <Tab value={key} key={key} disabled={!tabs[shownValue]}>
              {key}
            </Tab>
          ))}
        </TabList>
      </div>
      <div className="relative h-full">
        <div className="absolute top-0 left-0 h-full overflow-y-auto py-4 w-full">{tabs[shownValue]}</div>
      </div>
    </NavDrawer>
  );
};

/*
  <p className="mt-4 hidden">
    consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et
    consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et
  </p>
*/

export default ItemsNavDrawer;
